import "core-js/modules/es.object.to-string.js";
import _interopRequireWildcard from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/interopRequireWildcard";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchSwimmingOrderCheckList } from "@/api/PMS/swimming/swimmingOrderCheck";
import waves from "@/directive/waves";
import detail from "./detail";
import { formatJson } from "@/utils/index";
export default {
  name: "SwimmingOrderCheck",
  components: {
    detail: detail
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10
      },
      title: "",
      chooseItem: {},
      dialogFormVisible: false,
      dates: [],
      exLists: []
    };
  },
  created: function created() {
    if (this.$route.query.orderNo) {
      this.listQuery.orderNo = this.$route.query.orderNo;
    }

    this.getList();
  },
  methods: {
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;

      if (this.dates !== null && this.dates.length > 0) {
        this.listQuery.beginDate = this.dates[0];
        this.listQuery.endDate = this.dates[1];
      } else {
        this.listQuery.beginDate = "";
        this.listQuery.endDate = "";
      }

      fetchSwimmingOrderCheckList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleDetail: function handleDetail(data) {
      this.chooseItem = data;
      this.title = "核销详情";
      this.dialogFormVisible = true;
    },
    handleExport: function handleExport() {
      var _this2 = this;

      this.exLists = [];
      this.$confirm("你确定要导出游泳订单核销信息吗, 是否继续?", "提示").then(function () {
        fetchSwimmingOrderCheckList({
          orderNo: _this2.listQuery.orderNo,
          activityTitle: _this2.listQuery.activityTitle,
          itemName: _this2.listQuery.itemName,
          studentName: _this2.listQuery.studentName,
          tel: _this2.listQuery.tel,
          beginDate: _this2.listQuery.beginDate,
          endDate: _this2.listQuery.endDate
        }).then(function (response) {
          _this2.exLists = response.data.data;

          if (_this2.exLists !== null && _this2.exLists.length > 0) {
            Promise.resolve().then(function () {
              return _interopRequireWildcard(require("@/vendor/Export2Excel"));
            }).then(function (excel) {
              var tHeader = ["核销编号", "订单编号", "项目名称", "报名内容", "微信昵称", "姓名", "联系方式", "报名时间", "核销时间"];
              var fileterVal = ["serialNo", "orderNo", "activityTitle", "itemName", "nickName", "studentName", "tel", "enrollmentTime", "opDate"];
              var data = formatJson(fileterVal, _this2.exLists);
              excel.export_json_to_excel({
                header: tHeader,
                data: data,
                filename: "游泳订单核销信息",
                autoWidth: true,
                bookType: "xlsx"
              });
            });
          } else {
            _this2.$message.error("暂无数据，无法导出！");
          }
        });
      });
    }
  }
};